import { Controller } from "@hotwired/stimulus"

// Org-scoped Axle AI chat widget
// Sends questions to /axle_overlay with org context injected
export default class extends Controller {
  static targets = ["input", "messages", "suggestions", "loading", "sendBtn"]
  static values = { orgName: String, orgType: String }

  connect() {
    this.history = []
  }

  askSuggestion(event) {
    const question = event.currentTarget.dataset.question
    this.inputTarget.value = question
    this.send()
  }

  async send() {
    const message = this.inputTarget.value.trim()
    if (!message) return

    // Show messages area, hide suggestions
    this.messagesTarget.classList.remove("hidden")
    this.suggestionsTarget.classList.add("hidden")

    // Add user message
    this.appendMessage("user", message)
    this.inputTarget.value = ""

    // Show loading
    this.loadingTarget.classList.remove("hidden")
    this.sendBtnTarget.disabled = true

    try {
      const response = await fetch("/org_chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify({
          message: message,
          org_name: this.orgNameValue,
          org_type: this.orgTypeValue
        })
      })

      const data = await response.json()

      if (data.success && data.messages) {
        const assistantMsg = data.messages.find(m => m.role === "assistant")
        if (assistantMsg) {
          this.appendMessage("assistant", assistantMsg.content)
        }
      } else {
        this.appendMessage("assistant", data.error || "Sorry, I couldn't process that. Try again.")
      }
    } catch (error) {
      this.appendMessage("assistant", "Connection error. Please try again.")
    } finally {
      this.loadingTarget.classList.add("hidden")
      this.sendBtnTarget.disabled = false
      this.inputTarget.focus()
    }
  }

  appendMessage(role, content) {
    const div = document.createElement("div")

    if (role === "user") {
      div.className = "flex justify-end"
      div.innerHTML = `<div class="max-w-[85%] px-3.5 py-2 rounded-2xl rounded-br-md bg-white/10 text-white/90 text-sm leading-relaxed">${this.escapeHtml(content)}</div>`
    } else {
      div.className = "flex justify-start"
      div.innerHTML = `
        <div class="flex items-start gap-2 max-w-[90%]">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-emerald-500/20 flex items-center justify-center mt-0.5">
            <i class="fas fa-robot text-emerald-400 text-[9px]"></i>
          </div>
          <div class="px-3.5 py-2 rounded-2xl rounded-bl-md bg-white/[0.05] text-white/75 text-sm leading-relaxed">${this.escapeHtml(content)}</div>
        </div>`
    }

    this.messagesTarget.appendChild(div)
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
